import { render, staticRenderFns } from "./Increase.vue?vue&type=template&id=5ece16d2&"
import script from "./Increase.vue?vue&type=script&lang=js&"
export * from "./Increase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports